export default "__VITE_ASSET__CbpbHuzH__"